class StickyFilters extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        position: sticky;
        top: var(--Header_Height);
        z-index: 2;
        
        display: block;
        
        background-color: #fff;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver(
      ([entry]) => (this.isSticky = entry.intersectionRatio < 1),
      { threshold: [1] },
    )
    observer.observe(this)
  }

  get isSticky () {
    return this.hasAttribute('stuck')
  }

  set isSticky (val) {
    val ? this.setAttribute('stuck', '') : this.removeAttribute('stuck')
  }
}

if (!customElements.get('sticky-filters')) {
  customElements.define('sticky-filters', StickyFilters)
}
